// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-table {
  font-size: 0.875rem;
  transition-duration: 0.28s;
  transition-property: box-shadow, opacity, background, height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
:where(.vuetify-styles) .v-table {
  background: rgb(var(--v-theme-surface));
  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));
}
:where(.vuetify-styles) .v-table .v-table-divider {
  border-right: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}
:where(.vuetify-styles) .v-table .v-table__wrapper > table > thead > tr > th {
  border-bottom: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}
:where(.vuetify-styles) .v-table .v-table__wrapper > table > tbody > tr:not(:last-child) > td,
:where(.vuetify-styles) .v-table .v-table__wrapper > table > tbody > tr:not(:last-child) > th {
  border-bottom: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}
:where(.vuetify-styles) .v-table .v-table__wrapper > table > tfoot > tr > td,
:where(.vuetify-styles) .v-table .v-table__wrapper > table > tfoot > tr > th {
  border-top: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}
:where(.vuetify-styles) .v-table.v-table--hover > .v-table__wrapper > table > tbody > tr > td {
  position: relative;
}
:where(.vuetify-styles) .v-table.v-table--hover > .v-table__wrapper > table > tbody > tr:hover > td::after {
  background: rgba(var(--v-border-color), var(--v-hover-opacity));
  pointer-events: none;
}
:where(.vuetify-styles) .v-table.v-table--hover > .v-table__wrapper > table > tbody > tr:hover > td::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
:where(.vuetify-styles) .v-table.v-table--striped-even > .v-table__wrapper > table > tbody > tr:nth-child(even) {
  background-image: linear-gradient(0deg, rgba(var(--v-border-color), var(--v-hover-opacity)), rgba(var(--v-border-color), var(--v-hover-opacity)));
}
:where(.vuetify-styles) .v-table.v-table--striped-odd > .v-table__wrapper > table > tbody > tr:nth-child(odd) {
  background-image: linear-gradient(0deg, rgba(var(--v-border-color), var(--v-hover-opacity)), rgba(var(--v-border-color), var(--v-hover-opacity)));
}
:where(.vuetify-styles) .v-table.v-table--fixed-header > .v-table__wrapper > table > thead > tr > th {
  background: rgb(var(--v-theme-surface));
  box-shadow: inset 0 -1px 0 rgba(var(--v-border-color), var(--v-border-opacity));
  z-index: 1;
}
:where(.vuetify-styles) .v-table.v-table--fixed-footer > tfoot > tr > th,
:where(.vuetify-styles) .v-table.v-table--fixed-footer > tfoot > tr > td {
  background: rgb(var(--v-theme-surface));
  box-shadow: inset 0 1px 0 rgba(var(--v-border-color), var(--v-border-opacity));
}

:where(.vuetify-styles) .v-table {
  border-radius: inherit;
  line-height: 1.5;
  max-width: 100%;
  display: flex;
  flex-direction: column;
}
:where(.vuetify-styles) .v-table > .v-table__wrapper > table {
  width: 100%;
  border-spacing: 0;
}
:where(.vuetify-styles) .v-table > .v-table__wrapper > table > tbody > tr > td,
:where(.vuetify-styles) .v-table > .v-table__wrapper > table > tbody > tr > th,
:where(.vuetify-styles) .v-table > .v-table__wrapper > table > thead > tr > td,
:where(.vuetify-styles) .v-table > .v-table__wrapper > table > thead > tr > th,
:where(.vuetify-styles) .v-table > .v-table__wrapper > table > tfoot > tr > td,
:where(.vuetify-styles) .v-table > .v-table__wrapper > table > tfoot > tr > th {
  padding: 0 16px;
  transition-duration: 0.28s;
  transition-property: box-shadow, opacity, background, height;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
:where(.vuetify-styles) .v-table > .v-table__wrapper > table > tbody > tr > td,
:where(.vuetify-styles) .v-table > .v-table__wrapper > table > thead > tr > td,
:where(.vuetify-styles) .v-table > .v-table__wrapper > table > tfoot > tr > td {
  height: var(--v-table-row-height);
}
:where(.vuetify-styles) .v-table > .v-table__wrapper > table > tbody > tr > th,
:where(.vuetify-styles) .v-table > .v-table__wrapper > table > thead > tr > th,
:where(.vuetify-styles) .v-table > .v-table__wrapper > table > tfoot > tr > th {
  height: var(--v-table-header-height);
  font-weight: 500;
  font-size: inherit;
  -webkit-user-select: none;
          user-select: none;
  text-align: start;
}
:where(.vuetify-styles) .v-table--density-default {
  --v-table-header-height: 56px;
  --v-table-row-height: 52px;
}

:where(.vuetify-styles) .v-table--density-comfortable {
  --v-table-header-height: 48px;
  --v-table-row-height: 44px;
}

:where(.vuetify-styles) .v-table--density-compact {
  --v-table-header-height: 40px;
  --v-table-row-height: 36px;
}

:where(.vuetify-styles) .v-table__wrapper {
  border-radius: inherit;
  overflow: auto;
  flex: 1 1 auto;
}

:where(.vuetify-styles) .v-table--has-top > .v-table__wrapper {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

:where(.vuetify-styles) .v-table--has-bottom > .v-table__wrapper {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

:where(.vuetify-styles) .v-table--fixed-height > .v-table__wrapper {
  overflow-y: auto;
}

:where(.vuetify-styles) .v-table--fixed-header > .v-table__wrapper > table > thead {
  position: sticky;
  top: 0;
  z-index: 2;
}
:where(.vuetify-styles) .v-table--fixed-header > .v-table__wrapper > table > thead > tr > th {
  border-bottom: 0px !important;
}

:where(.vuetify-styles) .v-table--fixed-footer > .v-table__wrapper > table > tfoot > tr {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
:where(.vuetify-styles) .v-table--fixed-footer > .v-table__wrapper > table > tfoot > tr > td,
:where(.vuetify-styles) .v-table--fixed-footer > .v-table__wrapper > table > tfoot > tr > th {
  border-top: 0px !important;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VTable/VTable.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,4DAA4D;EAC5D,wDAAwD;AAC1D;AACA;EACE,uCAAuC;EACvC,sEAAsE;AACxE;AACA;EACE,6EAA6E;AAC/E;AACA;EACE,8EAA8E;AAChF;AACA;;EAEE,8EAA8E;AAChF;AACA;;EAEE,2EAA2E;AAC7E;AACA;EACE,kBAAkB;AACpB;AACA;EACE,+DAA+D;EAC/D,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;AACA;EACE,iJAAiJ;AACnJ;AACA;EACE,iJAAiJ;AACnJ;AACA;EACE,uCAAuC;EACvC,+EAA+E;EAC/E,UAAU;AACZ;AACA;;EAEE,uCAAuC;EACvC,8EAA8E;AAChF;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;;;;;;EAME,eAAe;EACf,0BAA0B;EAC1B,4DAA4D;EAC5D,wDAAwD;AAC1D;AACA;;;EAGE,iCAAiC;AACnC;AACA;;;EAGE,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;;EAEE,0BAA0B;AAC5B","sourcesContent":[".v-table {\n  font-size: 0.875rem;\n  transition-duration: 0.28s;\n  transition-property: box-shadow, opacity, background, height;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-table {\n  background: rgb(var(--v-theme-surface));\n  color: rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity));\n}\n.v-table .v-table-divider {\n  border-right: thin solid rgba(var(--v-border-color), var(--v-border-opacity));\n}\n.v-table .v-table__wrapper > table > thead > tr > th {\n  border-bottom: thin solid rgba(var(--v-border-color), var(--v-border-opacity));\n}\n.v-table .v-table__wrapper > table > tbody > tr:not(:last-child) > td,\n.v-table .v-table__wrapper > table > tbody > tr:not(:last-child) > th {\n  border-bottom: thin solid rgba(var(--v-border-color), var(--v-border-opacity));\n}\n.v-table .v-table__wrapper > table > tfoot > tr > td,\n.v-table .v-table__wrapper > table > tfoot > tr > th {\n  border-top: thin solid rgba(var(--v-border-color), var(--v-border-opacity));\n}\n.v-table.v-table--hover > .v-table__wrapper > table > tbody > tr > td {\n  position: relative;\n}\n.v-table.v-table--hover > .v-table__wrapper > table > tbody > tr:hover > td::after {\n  background: rgba(var(--v-border-color), var(--v-hover-opacity));\n  pointer-events: none;\n}\n.v-table.v-table--hover > .v-table__wrapper > table > tbody > tr:hover > td::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.v-table.v-table--striped-even > .v-table__wrapper > table > tbody > tr:nth-child(even) {\n  background-image: linear-gradient(0deg, rgba(var(--v-border-color), var(--v-hover-opacity)), rgba(var(--v-border-color), var(--v-hover-opacity)));\n}\n.v-table.v-table--striped-odd > .v-table__wrapper > table > tbody > tr:nth-child(odd) {\n  background-image: linear-gradient(0deg, rgba(var(--v-border-color), var(--v-hover-opacity)), rgba(var(--v-border-color), var(--v-hover-opacity)));\n}\n.v-table.v-table--fixed-header > .v-table__wrapper > table > thead > tr > th {\n  background: rgb(var(--v-theme-surface));\n  box-shadow: inset 0 -1px 0 rgba(var(--v-border-color), var(--v-border-opacity));\n  z-index: 1;\n}\n.v-table.v-table--fixed-footer > tfoot > tr > th,\n.v-table.v-table--fixed-footer > tfoot > tr > td {\n  background: rgb(var(--v-theme-surface));\n  box-shadow: inset 0 1px 0 rgba(var(--v-border-color), var(--v-border-opacity));\n}\n\n.v-table {\n  border-radius: inherit;\n  line-height: 1.5;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.v-table > .v-table__wrapper > table {\n  width: 100%;\n  border-spacing: 0;\n}\n.v-table > .v-table__wrapper > table > tbody > tr > td,\n.v-table > .v-table__wrapper > table > tbody > tr > th,\n.v-table > .v-table__wrapper > table > thead > tr > td,\n.v-table > .v-table__wrapper > table > thead > tr > th,\n.v-table > .v-table__wrapper > table > tfoot > tr > td,\n.v-table > .v-table__wrapper > table > tfoot > tr > th {\n  padding: 0 16px;\n  transition-duration: 0.28s;\n  transition-property: box-shadow, opacity, background, height;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-table > .v-table__wrapper > table > tbody > tr > td,\n.v-table > .v-table__wrapper > table > thead > tr > td,\n.v-table > .v-table__wrapper > table > tfoot > tr > td {\n  height: var(--v-table-row-height);\n}\n.v-table > .v-table__wrapper > table > tbody > tr > th,\n.v-table > .v-table__wrapper > table > thead > tr > th,\n.v-table > .v-table__wrapper > table > tfoot > tr > th {\n  height: var(--v-table-header-height);\n  font-weight: 500;\n  font-size: inherit;\n  user-select: none;\n  text-align: start;\n}\n.v-table--density-default {\n  --v-table-header-height: 56px;\n  --v-table-row-height: 52px;\n}\n\n.v-table--density-comfortable {\n  --v-table-header-height: 48px;\n  --v-table-row-height: 44px;\n}\n\n.v-table--density-compact {\n  --v-table-header-height: 40px;\n  --v-table-row-height: 36px;\n}\n\n.v-table__wrapper {\n  border-radius: inherit;\n  overflow: auto;\n  flex: 1 1 auto;\n}\n\n.v-table--has-top > .v-table__wrapper {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.v-table--has-bottom > .v-table__wrapper {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.v-table--fixed-height > .v-table__wrapper {\n  overflow-y: auto;\n}\n\n.v-table--fixed-header > .v-table__wrapper > table > thead {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n.v-table--fixed-header > .v-table__wrapper > table > thead > tr > th {\n  border-bottom: 0px !important;\n}\n\n.v-table--fixed-footer > .v-table__wrapper > table > tfoot > tr {\n  position: sticky;\n  bottom: 0;\n  z-index: 1;\n}\n.v-table--fixed-footer > .v-table__wrapper > table > tfoot > tr > td,\n.v-table--fixed-footer > .v-table__wrapper > table > tfoot > tr > th {\n  border-top: 0px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
